import { createStore, createTypedHooks } from 'easy-peasy';
import appModel from './app/appModel';
import AppModel from './app/types/AppModel';
import { getStoreName } from '../common/nameFormat';

const typedHooks = createTypedHooks<AppModel>();

export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;

export const store = createStore<AppModel>(appModel, {
  name: getStoreName(),
  version: 1,
});

export const getStore = () => store;
